import {
  useMutation,
  useQuery,
  useQueryClient
} from '@tanstack/react-query';
import axios from 'axios';
import { ContractEntity, ContractRequestEntity } from 'src/entities/contractEntity';

const getContract = (id: number) => async () => {
  const res = await axios.get<ContractEntity>(`/api/v5/master/contracts/${id}`);
  return res.data;
};

export const useQueryContract = (id: number) => useQuery({
  queryKey: ['contracts', { id }],
  queryFn: getContract(id),
  staleTime: Infinity,
  enabled: Boolean(id)
});

export const useMutationContract = () => {
  const queryClient = useQueryClient();
  return {
    addContract: useMutation({
      mutationFn: (contract: ContractRequestEntity | FormData) => {
        return axios.post('/api/v5/master/contracts', contract);
      },
      onSuccess: () => queryClient.invalidateQueries({ queryKey: ['contracts'] }),
    }),
    updateContract: useMutation({
      mutationFn: (data: ContractEntity | FormData) => {
        // FormDataの場合はget('id')でIDを取得、通常のオブジェクトの場合は.idでアクセス
        let id: number | string;
        if (data instanceof FormData) {
          const idValue = data.get('id');
          id = typeof idValue === 'string' ? idValue : '';
        } else {
          id = data.id;
        }
        return axios.put(`/api/v5/master/contracts/${id}`, data);
      },
      onSuccess: () => queryClient.invalidateQueries({ queryKey: ['contracts'] }),
    }),
    deleteContracts: useMutation({
      mutationFn: (ids: number[]) => {
        return axios.delete('/api/v5/master/contracts', { data: { ids } });
      },
      onSuccess: () => queryClient.invalidateQueries({ queryKey: ['contracts'] }),
    }),
  };
};
